"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadContractsForNetwork = exports.loadContracts = exports.loadContract = void 0;
const deployed_json_1 = __importDefault(require("@arcxgame/contracts/deployments/mainnet/deployed.json"));
const deployed_json_2 = __importDefault(require("@arcxgame/contracts/deployments/polygon/deployed.json"));
const deployed_json_3 = __importDefault(require("@arcxgame/contracts/deployments/mumbai/deployed.json"));
const deployed_json_4 = __importDefault(require("@arcxgame/contracts/deployments/rinkeby/deployed.json"));
const lodash_1 = __importDefault(require("lodash"));
function loadContract(params) {
    const results = loadContracts(params);
    if (results.length === 0) {
        throw Error(`No contracts found for ${JSON.stringify(params, null, 2)}`);
    }
    if (results.length > 1) {
        throw Error(`More than one contract found for ${JSON.stringify(params, null, 2)}`);
    }
    return results[0];
}
exports.loadContract = loadContract;
function loadContracts(params) {
    const contracts = loadContractsForNetwork(params.network);
    // If nothing was passed in
    if (lodash_1.default.isNil(params)) {
        throw Error('No name, type, source or group passed in');
    }
    // Remove the network from since we are already looking
    // in the right network
    const paramsWithoutNetwork = lodash_1.default.omit(params, 'network');
    return lodash_1.default.filter(contracts, lodash_1.default.matches(lodash_1.default.pickBy(paramsWithoutNetwork, lodash_1.default.identity)));
}
exports.loadContracts = loadContracts;
function loadContractsForNetwork(chainId) {
    switch (chainId) {
        case 'homestead':
        case '1':
            return deployed_json_1.default;
        case 'rinkeby':
        case '4':
            return deployed_json_4.default;
        case 'polygon':
        case '137':
            return deployed_json_2.default;
        case 'mumbai':
        case '80001':
            return deployed_json_3.default;
        default:
            return [];
    }
}
exports.loadContractsForNetwork = loadContractsForNetwork;
//# sourceMappingURL=loadContracts.js.map